<footer>
  <section class="left">©ERBO Engineering</section>
  <section class="right">KVK: 78040566</section>
</footer>
